<section class="footer" [ngClass]="!auth.IsAuthUser() ? 'logged-out' : '' ">
  <!--Footer Top-->
  <div class="footer-top">
    <div class="container container-super">
      <div class="footer-inner-top">
        <div class="footer-logo">
          <a routerLink="/"
            ><img src="assets/images/footer-logo.png" alt=""
          /></a>
        </div>
        <div class="ftop-right">
          <a class="phone" href="javascript:void(0);">03 9209 9000</a>
          <div class="email">join@cashelfo.com</div>
        </div>
      </div>

      <div class="footer-link-mobile">
        <mat-accordion>
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title> Wealth Services </mat-panel-title>
              <span class="material-icons remove-icon"> remove </span>
              <span class="material-icons add-icon"> add </span>
            </mat-expansion-panel-header>
            <div class="footer-widghet">
              <ul>
                <li><a href="javascript:void(0);">Plan</a></li>
                <li><a href="javascript:void(0);">Protect</a></li>
                <li><a href="javascript:void(0);">Invest</a></li>
                <li><a href="javascript:void(0);">Borrow</a></li>
                <li><a href="javascript:void(0);">Transform</a></li>
                <li><a href="javascript:void(0);">Organise</a></li>
              </ul>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel
          (opened)="panelOpenState = true"
          (closed)="panelOpenState = false"
        >
          <mat-expansion-panel-header>
            <mat-panel-title> Superannuation </mat-panel-title>
            <span class="material-icons remove-icon"> remove </span>
            <span class="material-icons add-icon"> add </span>
          </mat-expansion-panel-header>
          <div class="footer-widghet">
            <ul>
              <li><a href="javascript:void(0);">Why Cashel Super</a></li>
              <li><a href="javascript:void(0);">Find Lost Super</a></li>
              <li><a href="javascript:void(0);">Investment Options</a></li>
              <li><a href="javascript:void(0);">Insurance Options</a></li>
              <li><a href="javascript:void(0);">Contribution Options</a></li>
              <li><a href="javascript:void(0);">Join Cashel Super</a></li>
            </ul>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel
        (opened)="panelOpenState = true"
        (closed)="panelOpenState = false"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> Family Office </mat-panel-title>
          <span class="material-icons remove-icon"> remove </span>
          <span class="material-icons add-icon"> add </span>
        </mat-expansion-panel-header>
        <div class="footer-widghet">
          <ul>
            <li><a href="javascript:void(0);">Our Services</a></li>
            <li><a href="javascript:void(0);">Global Product Range</a></li>
            <li><a href="javascript:void(0);">Investment Platforms</a></li>
            <li><a href="javascript:void(0);">Join Cashel Family Office</a></li>
          </ul>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
      (opened)="panelOpenState = true"
      (closed)="panelOpenState = false"
    >
      <mat-expansion-panel-header>
        <mat-panel-title> About Us </mat-panel-title>
        <span class="material-icons remove-icon"> remove </span>
        <span class="material-icons add-icon"> add </span>
      </mat-expansion-panel-header>
      <div class="footer-widghet">
        <ul>
          <li><a href="javascript:void(0);">About Us</a></li>
          <li><a href="javascript:void(0);">Global Partnerships</a></li>
          <li><a href="javascript:void(0);">Community</a></li>
        </ul>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
    (opened)="panelOpenState = true"
    (closed)="panelOpenState = false"
  >
    <mat-expansion-panel-header>
      <mat-panel-title> Useful links </mat-panel-title>
      <span class="material-icons remove-icon"> remove </span>
      <span class="material-icons add-icon"> add </span>
    </mat-expansion-panel-header>
    <div class="footer-widghet">
      <ul>
        <li><a href="javascript:void(0);">Privacy Policy</a></li>
        <li><a href="javascript:void(0);">Conflicts of interest policy</a></li>
        <li><a href="javascript:void(0);">Forms</a></li>
      </ul>
    </div>
  </mat-expansion-panel>
    </mat-accordion>
      </div>

      <div class="footer-inner-bottom">
        <div class="links-col">
          <ul class="col m2">
            <li class="heading">Wealth Services</li>
            <li><a href="https://cashelfo.com/wealth/plan/" target="_blank">Plan</a></li>
            <li><a href="https://cashelfo.com/wealth/protect/" target="_blank">Protect</a></li>
            <li><a href="https://cashelfo.com/wealth/invest/" target="_blank">Invest</a></li>
            <li><a href="https://cashelfo.com/wealth/borrow/" target="_blank">Borrow</a></li>
            <li><a href="https://cashelfo.com/wealth/transform/" target="_blank">Transform</a></li>
            <li><a href="https://cashelfo.com/wealth/organise/" target="_blank">Organise</a></li>
          </ul>
          <ul class="col m2">
            <li class="heading">Superannuation</li>
            <li><a href="https://cashelfo.com/superannuation/why-cashel-super/" target="_blank">Why Cashel Super</a></li>
            <li><a href="https://cashelfo.com/superannuation/find-lost-super/" target="_blank">Find Lost Super</a></li>
            <li><a href="https://cashelfo.com/superannuation/investment-options/" target="_blank">Investment Options</a></li>
            <li><a href="https://cashelfo.com/superannuation/insurance-options/" target="_blank">Insurance Options</a></li>
            <li><a href="https://cashelfo.com/superannuation/contribution-options/" target="_blank">Contribution Options</a></li>
            <li><a href="https://cashelfo.com/join-cashel-super/" target="_blank">Join Cashel Super</a></li>
          </ul>
          <ul class="col m2">
            <li class="heading">Family Office</li>
            <li><a href="https://cashelfo.com/our-services/" target="_blank">Our Services</a></li>
            <li><a href="https://cashelfo.com/wealth/global-product-range/" target="_blank">Global Product Range</a></li>
            <li><a href="https://cashelfo.com/wealth/investment-platforms/" target="_blank">Investment Platforms</a></li>
            <li><a href="https://cashelfo.com/join-cashelfo/" target="_blank">Join Cashel Family Office</a></li>
          </ul>
          <ul class="col m2">
            <li class="heading">About Us</li>
            <li><a href="https://cashelfo.com/about-us/about-us/" target="_blank">About Us</a></li>
            <li><a href="https://cashelfo.com/about-us/global-partnerships/" target="_blank">Global Partnerships</a></li>
            <li><a href="https://cashelfo.com/about-us/community/" target="_blank">Community</a></li>
          </ul>
          <ul class="col m2">
            <li class="heading">Useful links</li>
            <li><a href="https://cashelfo.com/privacy-policy/" target="_blank">Privacy Policy</a></li>
            <li><a href="https://cashelfo.com/conflicts-of-interest-policy/" target="_blank">Conflicts of Interest Policy</a></li>
            <li><a href="https://cashelfo.com/forms/" target="_blank">Forms</a></li>
          </ul>
        </div>
      </div>
      <div class="copyright-col">
        <p>
          @2017, Cashel Family Office (Australia) Pty Ltd, All Right Reserved.
        </p>
        <ul class="social-icon">
          <li class="fb">
            <a href="https://www.facebook.com/CashelFamilyOffice/" target="_blind">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="19"
                viewBox="0 0 10 19"
              >
                <path
                  id="Facebook"
                  d="M1135.91,522v-8.5H1133v-3.377h2.91v-2.661a4.108,4.108,0,0,1,4.43-4.464,24.767,24.767,0,0,1,2.66.134v3.02h-1.83c-1.43,0-1.7.668-1.7,1.644v2.327h3.23l-.45,3.377h-2.78V522"
                  transform="translate(-1133 -503)"
                  fill="#fff"
                />
              </svg>
            </a>
          </li>
          <li class="twitter">
            <a href="https://twitter.com/cashelhg?lang=en" target="_blind">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21.25"
                height="17"
                viewBox="0 0 21.25 17"
              >
                <path
                  id="Twitter"
                  d="M1191.82,508.237c.01.186.01.372.01.558a12.207,12.207,0,0,1-12.39,12.2,12.448,12.448,0,0,1-6.69-1.926,9.106,9.106,0,0,0,1.05.053,8.816,8.816,0,0,0,5.41-1.832,4.345,4.345,0,0,1-4.07-2.975,5.693,5.693,0,0,0,.82.066,4.743,4.743,0,0,0,1.15-.146,4.31,4.31,0,0,1-3.5-4.21v-.053a4.463,4.463,0,0,0,1.97.544,4.261,4.261,0,0,1-1.35-5.737,12.461,12.461,0,0,0,8.98,4.489,5.351,5.351,0,0,1-.1-.983,4.319,4.319,0,0,1,4.35-4.29,4.368,4.368,0,0,1,3.18,1.355,8.684,8.684,0,0,0,2.77-1.036,4.3,4.3,0,0,1-1.92,2.364,8.8,8.8,0,0,0,2.51-.664A9.2,9.2,0,0,1,1191.82,508.237Z"
                  transform="translate(-1172.75 -504)"
                  fill="#fff"
                />
              </svg>
            </a>
          </li>
          <li class="insta">
            <a href="https://www.instagram.com/cashel_house/?hl=en" target="_blind">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                viewBox="0 0 19 19"
              >
                <path
                  id="Instagram"
                  d="M1222.5,507.623a4.978,4.978,0,0,1,2.42.678,4.552,4.552,0,0,1,1.78,1.782,4.712,4.712,0,0,1,0,4.877,4.556,4.556,0,0,1-1.78,1.781,5,5,0,0,1-4.88,0,4.492,4.492,0,0,1-1.78-1.781,4.965,4.965,0,0,1,0-4.877,4.488,4.488,0,0,1,1.78-1.782A4.979,4.979,0,0,1,1222.5,507.623Zm0,8.058a3.086,3.086,0,0,0,2.25-.933,3.118,3.118,0,0,0,.93-2.248,3.18,3.18,0,0,0-3.18-3.181,3.18,3.18,0,0,0-3.18,3.181,3.181,3.181,0,0,0,3.18,3.181Zm6.23-8.27a1.239,1.239,0,0,0-.33-.806,1.256,1.256,0,0,0-.81-.339,1.107,1.107,0,0,0-.81.339,1.077,1.077,0,0,0-.34.806,1.159,1.159,0,0,0,1.15,1.145.909.909,0,0,0,.76-.339A1.313,1.313,0,0,0,1228.73,507.411Zm3.23,1.145c0,.806.04,2.12.04,3.944,0,1.866-.04,3.181-.08,3.987a9.676,9.676,0,0,1-.34,2.078,5.087,5.087,0,0,1-1.19,1.866,5.143,5.143,0,0,1-1.83,1.145,7.541,7.541,0,0,1-2.12.382c-.8.042-2.12.042-3.94.042-1.87,0-3.18,0-3.99-.042a5.985,5.985,0,0,1-2.07-.425,4.341,4.341,0,0,1-1.87-1.1,5,5,0,0,1-1.15-1.866,7.254,7.254,0,0,1-.38-2.078c-.04-.806-.04-2.121-.04-3.987,0-1.824,0-3.138.04-3.944a7.563,7.563,0,0,1,.38-2.121,5.192,5.192,0,0,1,1.15-1.823,4.983,4.983,0,0,1,1.87-1.188,9.143,9.143,0,0,1,2.07-.339c.81-.043,2.12-.085,3.99-.085,1.82,0,3.14.042,3.94.085a9.522,9.522,0,0,1,2.12.339,5.268,5.268,0,0,1,3.02,3.011A13.279,13.279,0,0,1,1231.96,508.556Zm-2.04,9.542a9.823,9.823,0,0,0,.34-2.29c0-.594.04-1.484.04-2.629v-1.358c0-1.145-.04-2.035-.04-2.629a9.823,9.823,0,0,0-.34-2.29,3.207,3.207,0,0,0-1.82-1.824,10.152,10.152,0,0,0-2.29-.339c-.64,0-1.53-.043-2.63-.043h-1.36c-1.14,0-2.03.043-2.63.043a10.152,10.152,0,0,0-2.29.339,3.1,3.1,0,0,0-1.82,1.824,8.045,8.045,0,0,0-.34,2.29c-.04.636-.04,1.527-.04,2.629v1.358c0,1.145,0,2.035.04,2.629a8.045,8.045,0,0,0,.34,2.29,3.088,3.088,0,0,0,1.82,1.824,8.148,8.148,0,0,0,2.29.339c.6.043,1.49.043,2.63.043h1.36c1.14,0,2.03,0,2.63-.043a8.148,8.148,0,0,0,2.29-.339A3.207,3.207,0,0,0,1229.92,518.1Z"
                  transform="translate(-1213 -503)"
                  fill="#fff"
                />
              </svg>
            </a>
          </li>
          <li class="linkedin">
            <a href="https://www.linkedin.com/company/cashel-house/" target="_blind">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="16"
                viewBox="0 0 17 16"
              >
                <path
                  id="Linkedin"
                  d="M1256.81,520h-3.53V509.318h3.53Zm-1.77-12.139a1.933,1.933,0,1,1,2.04-1.94A2,2,0,0,1,1255.04,507.861ZM1270,520h-3.52v-5.2c0-1.239-.03-2.829-1.83-2.829-1.84,0-2.12,1.347-2.12,2.74V520h-3.52V509.318h3.38v1.457h.05a3.754,3.754,0,0,1,3.34-1.725c3.56,0,4.22,2.211,4.22,5.082V520Z"
                  transform="translate(-1253 -504)"
                  fill="#fff"
                />
              </svg>
            </a>
          </li>
          <li class="youtube">
            <a href="https://www.youtube.com/channel/UCybIhJCb54vaIgWfSTCj5VQ/featured" target="_blind">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19.92"
                height="14.25"
                viewBox="0 0 19.92 14.25"
              >
                <path
                  id="Youtube"
                  d="M1312.04,507.605a2.521,2.521,0,0,0-1.76-1.8c-1.55-.426-7.78-.426-7.78-.426s-6.23,0-7.78.426a2.521,2.521,0,0,0-1.76,1.8,28.91,28.91,0,0,0,0,9.819,2.483,2.483,0,0,0,1.76,1.775c1.55.426,7.78.426,7.78.426s6.23,0,7.78-.426a2.483,2.483,0,0,0,1.76-1.775,28.91,28.91,0,0,0,0-9.819Zm-11.58,7.923V509.5l5.21,3.013Z"
                  transform="translate(-1292.54 -505.375)"
                  fill="#fff"
                />
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </div>

  </div>
  <!--Footer Top-->
  <div class="footer-bottom">
    <div class="container container-super">
      <p class="copyright">
        Issued and maintained by Cashel Support Services Pty Ltd (ABN 31 619 697
        808, Authorised Representative Number 001257601 of Cashel Financial
        Services Pty Ltd, Australian Financial Services License and Australian
        Credit License No 306803)('Cashel'). Use of this website is subject to
        Cashel Financial Service Pty Ltd's Terms and Conditions and Privacy
        Policy.
      </p>
    </div>
  </div>
  <!--Footer Bottom-->
</section>
